// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay___djpi","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__1141c"};